// achivements section
var achievementTabsExist = document.getElementsByClassName('home-team');

if( achievementTabsExist.length > 0 ){
    const selectors = document.querySelectorAll('.home-team');

    for(i = 0; i < selectors.length; i++){
        var selector = selectors[i];

        if( null !== selector.id ){

            const tabItems = document.getElementById(selector.id).querySelectorAll('.home-team__nav__item');
            const tabContent = document.getElementById(selector.id).querySelectorAll('.home-team__block__content');

            function resetClasses() {
                tabItems.forEach( (item) => {
                    item.classList.remove('active');
                });
                tabContent.forEach((content) => {
                    content.classList.remove('active');
                });
            }

            tabItems.forEach( (item) => {
                let targetID = item.getAttribute('data-id');
                item.addEventListener('click', (e)=> {
                    e.preventDefault();
                    
                    resetClasses();
                    
                    e.target.classList.add('active');
                    document.querySelector('.home-team__block__content[data-block-id="'+targetID+'"]').classList.add('active');
                });
            });
        }
    }
}